module.exports = __webpack_public_path__ + "img/top.94ceeebd.png";